import { Component, OnInit } from "@angular/core";
import { User } from "../../models/user";
import { FireBaseService } from "../../services/firebase.service";
import { Observable } from "rxjs/Observable";
import {
  AngularFirestore,
  AngularFirestoreCollection
} from "angularfire2/firestore";

@Component({
  selector: "app-userlist",
  templateUrl: "./userlist.component.html",
  styleUrls: ["./userlist.component.css"]
})
export class UserlistComponent implements OnInit {
  userCollection: AngularFirestoreCollection<User>;
  users: Observable<User[]>;

  constructor(
    private firebaseService: FireBaseService,
    private afs: AngularFirestore
  ) {}

  ngOnInit() {
    this.userCollection = this.afs.collection("users", ref => {
      return ref;
    });
    this.users = this.userCollection.valueChanges();
    console.log(this.users);

   
  }
}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/userlist/userlist.component.ts